import { useState } from "react";

import AdminSection from "../../components/AdminSection/AdminSection";
import FiltrosHabilitarRegioes from "../../components/FiltrosHabilitarRegioes/FiltrosHabilitarRegioes";
import TabelaHabilitarRegioes from "../../components/TabelaHabilitarRegioes/TabelaHabilitarRegioes";
import NotifierPopup from '../../components/NotifierPopup/NotifierPopup';

import SyncAltRoundedIcon from '@mui/icons-material/SyncAltRounded';

export default function HabilitarRegioesAdm() {
    //Notifier
    const [ notify, setNotify ] = useState({
        isActive: false,
        isSuccessful: undefined,
        message: undefined
    });
    
    //Filtros
    const [ filtros, setFiltros ] = useState({
        id_regioes: 0,
        id_filiais: 0,
        isHabilitadas: ''    
    });
    
    //Data
    const [ regioes, setRegioes ] = useState(null);

    //Utils
    const [ load, setLoad ] = useState(false);

    return <>
        {notify.isActive && 
            <NotifierPopup 
                notify={notify}
                setNotify={setNotify}
            />
        }
        <AdminSection 
            etapa={<SyncAltRoundedIcon style={{width: '30px', height: '30px'}} />} 
            titulo={'Vincular regiões'}
            contexto={'Todas regiões selecionadas aparecerão nos indicadores do excelência'}
        >
            <div className="p-8">
                <div className="mb-8">
                    <FiltrosHabilitarRegioes
                        filtros={filtros}
                        setFiltros={setFiltros}
                        setRegioes={setRegioes}
                        setLoad={setLoad}
                    />
                </div>
                <TabelaHabilitarRegioes
                    filtros={filtros}
                    regioes={regioes}
                    setNotifier = {(isSuccess, message) => setNotify({
                        isActive: true,
                        isSuccessful: isSuccess,
                        message: message
                    })}
                />
            </div>
        </AdminSection>
    </>
}